import './Ajuda.css';

// Guia do gestor: explica o fluxo completo de liberar e manter o acesso dos fornecedores.
// Fica no menu da Administração — é a referência pra quem gerencia (sem precisar perguntar).
export default function Ajuda() {
  return (
    <div style={{ maxWidth: 860 }}>
      <h4 className="fw-bold mb-1">
        <i className="bi bi-question-circle me-2" style={{ color: 'var(--primary)' }} />
        Ajuda — como funciona o portal
      </h4>
      <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
        Guia de quem gerencia o acesso dos fornecedores. Do cadastro ao dia a dia.
      </p>

      <div className="aj-intro">
        O <b>Portal do Fornecedor</b> deixa a indústria acompanhar, por conta própria, o que ela vende pro Centrão:
        mix de produtos com foto, estoque loja a loja, amostras nos mostruários e as vendas por filial e por vendedor.
        <br />
        Quem entra são <b>duas turmas</b>: a <b>equipe Centrão</b> (você, com o mesmo login do sistema interno) para
        administrar os acessos, e as <b>pessoas do fornecedor</b>, com login próprio que <b>você cria</b> — cada uma
        vendo somente os dados do CNPJ dela.
      </div>

      {/* ---------- Fluxo principal ---------- */}
      <div className="aj-secao"><i className="bi bi-signpost-split" />Liberando um fornecedor novo</div>
      <div className="aj-secao-sub">O caminho completo, do zero até ele conseguir entrar. São 4 passos.</div>

      <div className="aj-passos">
        <div className="aj-passo">
          <div className="aj-num">1</div>
          <div className="aj-passo-corpo">
            <div className="aj-passo-titulo">Cadastre a empresa (o CNPJ)</div>
            <div className="aj-passo-txt">
              No menu <span className="aj-menu-ref"><i className="bi bi-building" />Fornecedores</span>, use o campo
              <b> “Buscar fornecedor no ERP”</b> — pode procurar por nome, CNPJ ou código. Achou? Clique em
              <span className="aj-btn-ref">Cadastrar</span>.
              <br />
              Os dados vêm do <b>ERP (Microuniverso)</b>, você não digita nada à mão. Se a empresa tem mais de um CNPJ,
              cadastre <b>cada CNPJ</b> — depois eles podem ser reunidos numa pessoa só (veja abaixo).
            </div>
          </div>
        </div>

        <div className="aj-passo">
          <div className="aj-num">2</div>
          <div className="aj-passo-corpo">
            <div className="aj-passo-titulo">Crie o usuário da pessoa de contato</div>
            <div className="aj-passo-txt">
              Na lista, clique na linha do fornecedor (ou no botão <b>Usuários</b>). No bloco <b>“Novo usuário”</b>,
              preencha <b>Usuário (login)</b>, <b>Nome</b> e, se souber, o <b>E-mail</b> — e clique em
              <span className="aj-btn-ref">Criar</span>.
              <br />
              O login é livre e não precisa ser o CNPJ. Use um padrão fácil, tipo <code>joao.novaporcelanato</code>.
              Um mesmo CNPJ pode ter <b>quantas pessoas você quiser</b>.
            </div>
          </div>
        </div>

        <div className="aj-passo">
          <div className="aj-num">3</div>
          <div className="aj-passo-corpo">
            <div className="aj-passo-titulo">Repasse a senha provisória</div>
            <div className="aj-passo-txt">
              Assim que criar, aparece uma <b>senha provisória</b> em destaque, com botão <b>Copiar</b>. Mande pra pessoa
              (WhatsApp, e-mail, como preferir).
              <br />
              <b>Atenção:</b> ela aparece <b>uma única vez</b>. Se fechar sem copiar, sem problema — basta gerar outra em
              <span className="aj-btn-ref">Resetar senha</span>.
            </div>
          </div>
        </div>

        <div className="aj-passo">
          <div className="aj-num">4</div>
          <div className="aj-passo-corpo">
            <div className="aj-passo-titulo">A pessoa conclui o primeiro acesso</div>
            <div className="aj-passo-txt">
              Ela entra em <b>fornecedores.centraomateriais.com</b> com o login e a senha provisória. O sistema então
              <b> obriga</b> ela a informar o <b>e-mail</b> e criar uma <b>senha pessoal</b> — só depois libera as telas.
              <br />
              Esse e-mail é o que permite ela mesma recuperar a senha depois, sem te acionar. Pronto: acesso liberado.
            </div>
          </div>
        </div>
      </div>

      {/* ---------- Dia a dia ---------- */}
      <div className="aj-secao"><i className="bi bi-tools" />Situações do dia a dia</div>
      <div className="aj-secao-sub">O que fazer em cada caso que costuma aparecer.</div>

      <div className="aj-grid">
        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-diagram-3" />A indústria tem vários CNPJs</div>
          <div className="aj-card-txt">
            Comum na indústria. Cadastre <b>cada CNPJ</b> (passo 1). Depois, em <b>Usuários</b>, clique em
            <b> Editar</b> na pessoa e use <b>“CNPJs que este usuário acessa”</b> para vincular os outros.
            <br />
            Ela passa a ver <b>tudo junto</b> e ganha um filtro <b>Fornecedor</b> nas telas, pra olhar uma marca por vez.
          </div>
        </div>

        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-key" />“Esqueci minha senha”</div>
          <div className="aj-card-txt">
            Se ela <b>tem e-mail cadastrado</b>, resolve sozinha: na tela de login existe o link
            <b> “Esqueci minha senha”</b> e uma senha nova chega no e-mail dela.
            <br />
            Se <b>não tiver e-mail</b>, você resolve: <b>Editar</b> para cadastrar o e-mail, ou
            <span className="aj-btn-ref">Resetar senha</span> e repassar a provisória.
          </div>
        </div>

        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-pencil" />Corrigir nome ou e-mail</div>
          <div className="aj-card-txt">
            Botão <b>Editar</b> na linha da pessoa. Dá pra ajustar o <b>nome</b> e o <b>e-mail</b> a qualquer momento.
            <br />
            O <b>login</b> não muda — se estiver errado, crie o usuário certo e exclua o errado.
          </div>
        </div>

        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-person-dash" />Tirar o acesso de alguém</div>
          <div className="aj-card-txt">
            Prefira <b>Desativar</b>: ela perde o acesso na hora, mas o cadastro fica registrado — e é só
            <b> Ativar</b> pra voltar (ex.: pessoa de férias ou que saiu da empresa).
            <br />
            Use <b>Excluir</b> só quando o cadastro foi um erro — apaga de vez, sem desfazer.
          </div>
        </div>

        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-building-slash" />Suspender a empresa toda</div>
          <div className="aj-card-txt">
            Na lista de <b>Fornecedores</b>, use <b>Desativar</b> na linha do CNPJ. <b>Todas</b> as pessoas daquele
            CNPJ perdem o acesso de uma vez — útil ao encerrar a parceria.
            <br />
            Depois basta <b>Ativar</b> pra liberar todo mundo de novo.
          </div>
        </div>

        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-people" />Conferir quem tem acesso</div>
          <div className="aj-card-txt">
            Na lista de <b>Fornecedores</b>, a coluna <b>Usuários</b> mostra quantas pessoas acessam aquele CNPJ.
            <br />
            Dentro, o selo <b>“senha provisória”</b> indica quem <b>ainda não fez o primeiro acesso</b> — ótimo pra
            cobrar quem recebeu a senha e não entrou.
          </div>
        </div>
      </div>

      {/* ---------- O que o fornecedor vê ---------- */}
      <div className="aj-secao"><i className="bi bi-eye" />O que o fornecedor vê depois de entrar</div>
      <div className="aj-secao-sub">Útil pra você explicar o valor do portal na conversa com a indústria.</div>

      <div className="aj-grid">
        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-grid" />Meu Mix</div>
          <div className="aj-card-txt">
            O catálogo dos produtos dele no Centrão, <b>com foto</b>. Tem também <b>estoque loja a loja</b> e o mapa de
            <b> amostras</b> — em quais mostruários cada produto está exposto.
          </div>
        </div>
        <div className="aj-card">
          <div className="aj-card-titulo"><i className="bi bi-graph-up" />Vendas</div>
          <div className="aj-card-txt">
            Vendas <b>por filial</b> e <b>por vendedor</b> (clicando no vendedor, abre os produtos), em metros e em
            valor. Tem ainda a aba <b>Giro</b>, com estoque de hoje, o que está <b>a chegar</b> de compra e a
            <b> cobertura</b> (quantos meses o estoque dura). E dá pra exportar o <b>sell-out semanal em Excel</b>.
          </div>
        </div>
      </div>

      {/* ---------- Avisos ---------- */}
      <div className="aj-secao"><i className="bi bi-exclamation-triangle" />Regras que valem lembrar</div>
      <div className="aj-secao-sub">Quatro pontos que evitam quase toda dúvida.</div>

      <div className="aj-avisos">
        <div className="aj-aviso">
          <i className="bi bi-shield-lock" />
          <div><b>Cada um vê só o que é seu.</b> O fornecedor enxerga apenas os produtos e as vendas do próprio CNPJ.
          Não existe risco de um ver os dados do outro — o sistema trava isso no login, não depende de configuração sua.</div>
        </div>
        <div className="aj-aviso">
          <i className="bi bi-database-check" />
          <div><b>O portal só lê o ERP.</b> Cadastrar um fornecedor aqui <b>não muda nada</b> no Microuniverso — nem
          preço, nem estoque, nem cadastro. O portal apenas mostra o que já existe lá.</div>
        </div>
        <div className="aj-aviso">
          <i className="bi bi-envelope-at" />
          <div><b>Insista no e-mail.</b> É o que permite a pessoa recuperar a senha sozinha. Sem e-mail, toda
          recuperação passa por você.</div>
        </div>
        <div className="aj-aviso">
          <i className="bi bi-clock-history" />
          <div><b>Os dados são do ERP, atualizados na hora.</b> Estoque e vendas refletem o sistema interno. Se um
          número parecer estranho, quase sempre a resposta está no cadastro do produto no ERP.</div>
        </div>
      </div>

      <div className="aj-intro" style={{ marginTop: 26, marginBottom: 8 }}>
        <b>Ficou alguma dúvida que este guia não cobre?</b> Fale com a TI/Desenvolvimento do Centrão — vale registrar
        a dúvida pra ela entrar aqui e virar resposta pronta pro próximo.
      </div>
    </div>
  );
}
